import axios from "axios";

// API base URL resolution.
// Strategy: use the current page origin when we're on a real domain
// (e.g. maqam-ksa.com), so each deployment talks to its OWN backend instead
// of every build hard-coding the preview URL.
// Falls back to REACT_APP_BACKEND_URL for SSR / build-time scenarios where
// `window` is unavailable.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return envUrl;
  try {
    const here = window.location.origin;
    // If we're on localhost dev or the env URL exactly matches the page,
    // use the env URL as configured.
    if (!envUrl) return here;
    const envHost = new URL(envUrl).host;
    const pageHost = window.location.host;
    // If the page host differs from the configured backend host, prefer
    // same-origin so production at maqam-ksa.com doesn't accidentally call
    // the preview backend (and end up with cross-domain OAuth bounces).
    if (envHost !== pageHost) return here;
    return envUrl;
  } catch {
    return envUrl || window.location.origin;
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("jf_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalize FastAPI's structured error details ({code, message}) so that
    // page code calling `toast.error(err.response.data.detail)` never tries
    // to render an object as a React child. We keep the original under
    // `detail_obj` for any code that needs the structured form.
    const d = err?.response?.data?.detail;
    if (d && typeof d === "object" && !Array.isArray(d)) {
      const msg = typeof d.message === "string" ? d.message
                : typeof d.msg === "string" ? d.msg
                : JSON.stringify(d);
      err.response.data.detail_obj = d;
      err.response.data.detail = msg;
    }
    if (err?.response?.status === 401) {
      // keep token for debugging but redirect handled in AuthContext
    }
    return Promise.reject(err);
  }
);
